import { useLayoutEffect } from "react";
import compensateScrollDecoration, {
  OVERFLOW_HIDDEN_CLASS,
} from "../helpers/compensateScrollDecoration";

/** Toggles styles / css classes on body */
const useBodyOverflow = (state: boolean): void => {
  /** UseLayoutEffect instead of useEffect because of document.body size calculations */
  useLayoutEffect(() => {
    const decorations = compensateScrollDecoration(state);
    /** !!! Attention !!! Raw `body` properties mutation */
    document.body.style.paddingRight = decorations.style.paddingRight as string;
    document.body.classList.toggle(OVERFLOW_HIDDEN_CLASS, state);

    return () => {
      /** cleanup on onmount */
      document.body.style.paddingRight = null;
      document.body.classList.remove(OVERFLOW_HIDDEN_CLASS);
    };
  }, [state]);
};

export default useBodyOverflow;
